import { useAuth } from "@/context/AuthContext";

/**
 * Wrap any pricing / margin / revenue display in `<PriceGuard>` so it's hidden
 * for users who don't have permission. Admin + compta always see prices.
 * Everyone else needs `can_see_prices=true`.
 *
 * Usage:
 *   <PriceGuard>{formatEuros(revenue)}</PriceGuard>
 *   <PriceGuard fallback="—">…</PriceGuard>
 */
export default function PriceGuard({ children, fallback = null }) {
  const { user } = useAuth();
  if (!user) return null;
  const allowed = user.role === "admin" || user.role === "compta" || user.can_see_prices === true;
  if (!allowed) return fallback;
  return children;
}

export function canSeePrices(user) {
  if (!user) return false;
  return user.role === "admin" || user.role === "compta" || user.can_see_prices === true;
}

export function formatEuros(n) {
  if (n == null || Number.isNaN(Number(n))) return "—";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Number(n));
}
